// Module
var code = "<div class=\"internal-server-error\"><div class=\"message\" ng-bind-html=\"formattedMessage\"></div><button ng-click=\"dismiss()\" name=\"dismiss\" class=\"modal-action-button\" translate-once=\"front_royal_api_error_handler.internal_server_error.continue\"></button></div>";
// Exports
export default code;